module.exports = __webpack_public_path__ + "img/industryAdvisory.c4b2fb87.jpg";